/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) System SaveExport Icon component.
 */
export const SystemSaveExportIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='SystemSaveExportIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        <path d='M19.766 11.143v8.782a.5.5 0 01-.5.5H4.5a.5.5 0 01-.5-.5V5.16a.5.5 0 01.5-.5h8.085'
          stroke={iconColor}
          strokeWidth={1.5}
          strokeMiterlimit={10} />
        <path d='M20.373 7.149L20.596 3l-4.98.26M20.596 3l-7.468 7.468'
          stroke={iconColor}
          strokeWidth={1.5}
          strokeLinecap='round'
          strokeLinejoin='round' />
      </svg>
    )} />
  );
};
